import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const TOKEN_KEY = 'arcana_auth_token';

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export async function login({ email, password }) {
  const { data } = await client.post('/auth/login', { email, password });
  setToken(data.token);
  return data.user;
}

export async function register({ email, password, name }) {
  const { data } = await client.post('/auth/register', { email, password, name });
  setToken(data.token);
  return data.user;
}

export async function fetchMe() {
  const { data } = await client.get('/auth/me');
  return data.user;
}

export function logout() {
  setToken(null);
}

const authService = { login, register, fetchMe, logout, getToken, setToken };
export default authService;
